import { makeStyles } from "tss-react/mui";

export const HeaderLinksStyle = makeStyles()(
    (theme, p, classes) => ({

        buttonContainer: {
            display: "flex",
            "& img": {
                borderRadius: "50%"
            },
            "& > button:first-of-type": {
                marginLeft: 0
            }
        },

        buttonMenu: {
            ...theme.extended.workArea.header.iconButton,
            minWidth: "unset",
            marginRight: 8,
            marginLeft: 8,
            height: "var(--header-height)",
            display: "flex",
        },

        buttonRegularCounter: {
            zIndex: 4,
            position: "absolute",
            top: "14px",
            right: "0",
            border: "1px solid #FFF",
            fontSize: "9px",
            background: theme.palette.error.dark,
            color: theme.palette.error.contrastText,
            minWidth: "16px",
            borderRadius: "10px",
            textAlign: "center",
            lineHeight: "16px",
            verticalAlign: "middle",
            display: "block"
        },

        buttonPriorityCounter: {
            zIndex: 4,
            position: "absolute",
            top: "14px",
            right: 4,
            display: "block",
        },

        popperNav: {
            zIndex: theme.zIndex.drawer
        },

        popperClose: {
            pointerEvents: "none"
        },
    })
);
